import { Component, OnInit, Input, Output, EventEmitter, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { fciWebsiteService } from '../../service/fci-website.service';
import { CustomServiceService } from '../../service/custom-service.service';
import {  EncryptDecryptService } from '../../service/encrypt-decrypt.service';
import { HttpEvent, HttpEventType } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';

import { FormControl, FormGroup, Validators } from '@angular/forms';
declare let $: any;
import * as CryptoJS from "crypto-js"; 
import { Buffer } from 'buffer';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-employee-corner',
  templateUrl: './employee-corner.component.html', 
  styleUrls: ['./employee-corner.component.css']
})
export class EmployeeCornerComponent implements OnInit {

  constructor(private fciwebservice: fciWebsiteService, private httpservice: CustomServiceService, private routerparam: ActivatedRoute, private encDec:EncryptDecryptService,private route: Router, public translate: TranslateService) { }
  backend_url: any = environment.serviceURL;
  start:number=0;
  limit:number=20;
  currentPage:number = 1; 
  totalRecords:number=0;

  a_start:number=0; 
  a_limit:number=20;
  a_currentPage:number = 1;
  a_totalRecords:number=0;
  language:any = "";

  plugin_menu_dtl:any;
  employee_con:any="";
  showEmpMen:boolean=false;
  showNavComponent:boolean=false; 
  showBarComponent:boolean=false;
  CurrentRouteFn:any = ():any => {
    let route_url:any = this.route.url.replace('/',"");
    route_url = route_url.split("?");
    if(route_url.length > 0){
      return route_url[0];
    }
    return route_url;
  }

  CURRENT_ZONE_ID:any = environment.ZONE_ID;
  CURRENT_REGION_ID:any = environment.REGION_ID;
  CURRENT_ZONE_CODE:any = environment.ZONE_CODE;
  CURRENT_REGION_CODE:any = environment.REGION_CODE;
  datetime:any = this.httpservice.currentDateTime();
  ngOnInit(): void { 
    this.language = sessionStorage.getItem('locale');//dynamic
    document.title='Employee Corner';
    this.start=(this.currentPage - 1)*this.limit;
    this.getEmpeeloyCornerDoc(this.start,this.limit,this.currentPage);
    this.a_start=(this.currentPage - 1)*this.a_limit;
    this.getEmpeeloyCornerApp(this.a_start,this.a_limit,this.a_currentPage);

    this.employee_con = this.routerparam.snapshot.queryParamMap.get('emp');
    if(this.employee_con==null){
      this.plugin_menu_dtl = window.sessionStorage.getItem(btoa(this.CurrentRouteFn()));
      this.getPluginPageDetials(this.plugin_menu_dtl);
    } else {
      this.getEmployeeCornerDtl(this.encDec.decText(this.employee_con));
    }
  }




  pageChanged(page: any) {
    this.currentPage=page
    this.start=(this.currentPage - 1)*this.limit;
    this.getEmpeeloyCornerDoc(this.start,this.limit,this.currentPage);
  }

  htmldecode(str: any){
    return this.encDec.decodeHtml(str);
  }

  conrner_apirespons: any;
  conrnerList: any[] = [];
  getEmpeeloyCornerDoc(start:number,limit:number,currentPage:number) { 
    var query:any = [];
    query = [
      { "columnName": "tinPublishStatus", "operator": "=", "value": "1", "joinoperator": "and" },
      { "columnName": "bitDeletedFlag", "operator": "=", "value": "0", "joinoperator": "and" },
      { "columnName": "INTTYPE", "operator": "=", "value": 1, "joinoperator": "and" },
    ];
    if(environment.ZONE_ID > 0){
      query.push({ "columnName": "ZONE_ID", "operator": "=", "value": environment.ZONE_ID, "joinoperator": "and" });
     }
    let params = [
      {
        "secSlNo": 1,
        "offSet": start,
        "noOfRecords": limit,
        "orderBy": [{ "columnName": "intId", "type": "DESC" }],
        "condition": query,
        "viewParameters": ""
      }];
    this.httpservice.EmpeeloyCorner(params).subscribe((response: any) => {
      switch (response.type) { 
        case HttpEventType.Sent:
          //console.log('Sent' + HttpEventType.Sent);
          break;
        case HttpEventType.ResponseHeader:
          //console.log('ResponseHeader' + HttpEventType.ResponseHeader);
          break;
        case HttpEventType.UploadProgress:
          //  let total = response.total?response.total:0;
          //  console.log(Math.round(response.loaded / total * 100));
          break;
        case HttpEventType.Response:
        this.conrner_apirespons = response.body;
        let respData = this.conrner_apirespons.RESPONSE_DATA;
        let respToken = this.conrner_apirespons.RESPONSE_TOKEN;
        let verifyToken = CryptoJS.HmacSHA256(respData,environment.apiHashingKey).toString();
        if (respToken == verifyToken) {
          let response_: any = Buffer.from(respData, 'base64');
          response_ = JSON.parse(response_);
          this.conrnerList = response_.result.sec_1;
          if(response_.result.sec_1.length > 0){
            this.totalRecords = response_.result.sec_1[0].noOfRec;
          } else {
            this.totalRecords = 0;
          }
        } 
      }
    });
  }
 
 CkeckFiles(item:[]):any{
  if(item.length >= 2){
    return 2;
  } else if(item.length >=1){
    return 1;
  }
  return 0; 
 }

  a_pageChanged(page: any) {
    this.a_currentPage=page
    this.a_start=(this.a_currentPage - 1)*this.a_limit;
    this.getEmpeeloyCornerApp(this.a_start,this.a_limit,this.a_currentPage)
  }

  app_apirespons: any;
  applicationList: any[] = [];
  getEmpeeloyCornerApp(start:number,limit:number,currentPage:number) { 
    var query:any = [];
    query = [
      { "columnName": "tinPublishStatus", "operator": "=", "value": "1", "joinoperator": "and" },
      { "columnName": "bitDeletedFlag", "operator": "=", "value": "0", "joinoperator": "and" },
      { "columnName": "INTTYPE", "operator": "=", "value": 2, "joinoperator": "and" },
    ];
    if(environment.ZONE_ID > 0){
      query.push({ "columnName": "ZONE_ID", "operator": "=", "value": environment.ZONE_ID, "joinoperator": "and" });
     }
    let params = [
      {
        "secSlNo": 1,
        "offSet": start,
        "noOfRecords": limit,
        "orderBy": [{ "columnName": "intId", "type": "DESC" }],
        "condition": query,
        "viewParameters": ""
      }];
    this.httpservice.EmpeeloyCorner(params).subscribe((response: any) => {
      switch (response.type) { 
        case HttpEventType.Sent:
          //console.log('Sent' + HttpEventType.Sent);
          break;
        case HttpEventType.ResponseHeader:
          //console.log('ResponseHeader' + HttpEventType.ResponseHeader);
          break;
        case HttpEventType.UploadProgress:
          //  let total = response.total?response.total:0;
          //  console.log(Math.round(response.loaded / total * 100));
          break;
        case HttpEventType.Response:
        this.app_apirespons = response.body;
        let respData = this.app_apirespons.RESPONSE_DATA;
        let respToken = this.app_apirespons.RESPONSE_TOKEN;
        let verifyToken = CryptoJS.HmacSHA256(respData,environment.apiHashingKey).toString();
        if (respToken == verifyToken) {
          let response_: any = Buffer.from(respData, 'base64');
          response_ = JSON.parse(response_);
          // console.log(response_.result.sec_1);
          this.applicationList = response_.result.sec_1;
          if(response_.result.sec_1.length > 0){
            this.a_totalRecords = response_.result.sec_1[0].noOfRec;
          } else {
            this.a_totalRecords = 0;
          }
        } 
      }
    });
  }



  jsonConvert(data: any, type: any) {
    if(data=="" || data==null){
      return "";
    }
    if(data.jsonOptTxtDetails=="" || data.jsonOptTxtDetails == null){
      return "";
    }
    let d = JSON.parse(data.jsonOptTxtDetails);
    if (type == 'FROM_YEAR') {
      return d.FROM_YEAR;
    } else if (type == 'TO_YEAR') {
      return d.TO_YEAR;
    } else {
      return '';
    }

  }

htmlTag(data:any){
  return this.encDec.decodeHtml(data);
}

encode(data:any){
  return btoa(data);
}


ViewDocument(url:any,f:any):any{
  if(f==''){
    return false;
  }
  var strWindowFeatures = "location=yes,height=870,width=620,scrollbars=yes,status=yes";
  window.open( `${url}${f}`, "_blank",strWindowFeatures);
}

getlastTwo(d:any){
  if(d==""){
    return "";
  }
  let exd = d.split(" ");
  if(exd.length <= 0){
    return "";
  }
  let exdate = exd[0].split("/");
  if(exdate.length <  3){
    return "";
  }
  return exdate[2].replace(",", " ");
}



viewDetails(id: any, pageName: any,type:any){
  let x = `${id}-${type}`;
  let encSchemeStr = this.encDec.encText(x.toString());
  this.route.navigate(['/'+ pageName +'/', encSchemeStr]);
}

 
goToContentPage(selectPage:any,id:any)
{   
    let encSchemeStr = this.encDec.encText(id.toString());
    // this.route.navigate(['./view',`${selectPage}?emp=${encSchemeStr}`]); 
    this.route.navigateByUrl(`/view/${selectPage}?emp=${encSchemeStr}`);
} 

goToPluginPage(selectPage:any,id:any)
{
 let encSchemeStr = this.encDec.encText(id.toString());
 //  this.route.navigateByUrl(`/${selectPage}?emp=${encSchemeStr}`);
 this.route.navigateByUrl('/', { skipLocationChange: true }).then(() =>
 this.route.navigate([selectPage], { queryParams: {'emp': encSchemeStr}}));
}

goToExtLink(url:any)
{
   Swal.fire({
    title: 'You are being redirected to an external website. Please note that Food Corporation of India (FCI) cannot be held responsible for external websites content & privacy policies.',
    text: 'Are you sure?',
    showCancelButton: true, 
    confirmButtonText: 'Yes',
    cancelButtonText: 'No'
  }).then((result) => {
    if (result.value) {
      window.open(url, '_blank');
  }
});
}
  

checkFileExists(obj:any):boolean{
  if(obj.selectDocument==""){
    return false;
  }
  if(obj.selectDocument_details==undefined){
    return false;
   }
  if(obj.selectDocument_details.fileSize==undefined){
    return false;
   }
 if(obj.selectDocument_details.fileSize==""){
  return false;
 }
return true;
}

Files_:any = (data:any)=>{
  if(data==""){
    return [];
  }
  if(data.length <= 0){
    return [];
  }
  var list = [];
  for (let i = 0; i < data.length; i++) {
      if(data[i].selectFile!==''){
        if(data[i].selectFile_details.fileSize!==''){
          list.push(data[i]);
        }
      }  
  } 
  return list;
}

 



emp_apires:any;
emp_dtl:any={'title':''};
getEmployeeCornerDtl(id:any){
  let params = [
    {
      "secSlNo": 1,
      "offSet": 0,
      "noOfRecords": 0,
      "orderBy": [],
      "condition": [ 
        { "columnName": "tinPublishStatus", "operator": "=", "value": "1", "joinoperator": "and" },
        { "columnName": "bitDeletedFlag", "operator": "=", "value": "0", "joinoperator": "and" },
        { "columnName": "intId", "operator": "=", "value":id, "joinoperator": "and" },
      ],
      "viewParameters": ""
    }];
  this.httpservice.EmpeeloyCorner(params).subscribe((response: HttpEvent<any>) => {
    switch (response.type) {
      case HttpEventType.Sent:
        //console.log('Sent' + HttpEventType.Sent);
        break;
      case HttpEventType.ResponseHeader:
        //console.log('ResponseHeader' + HttpEventType.ResponseHeader);
        break;
      case HttpEventType.UploadProgress:
        //this.evenTotal = response.total;
        //this.progress = Math.round(response.loaded / this.evenTotal * 100);
        break; 
      case HttpEventType.Response:
      this.emp_apires = response.body;
      let respData = this.emp_apires.RESPONSE_DATA;
      let respToken = this.emp_apires.RESPONSE_TOKEN;
      let verifyToken = CryptoJS.HmacSHA256(respData,environment.apiHashingKey).toString();
      if (respToken == verifyToken) { 
        let response_: any = Buffer.from(respData, 'base64');
        response_ = JSON.parse(response_);
        if(response_.result.sec_1.length > 0){
          this.emp_dtl=response_.result.sec_1[0];
          this.showBarComponent=true;
          this.showEmpMen = true;
        }
        // console.log(this.emp_dtl.title);
      } 
    }
  });
}











navmenuloadCss = "background-color: #167a44; height: 100%;";
p_apirespons: any;
P_data: any;

navMenu:boolean=false;
getPluginPageDetials(details:any) {
  let params; 
  if(details!==null){
    let d = JSON.parse(details);
     params = {
      "zone_id": environment.ZONE_ID,
      "zone_code": environment.ZONE_CODE,
      "region_id": environment.REGION_ID,
      "region_code": environment.REGION_CODE,
      "plugin_id": d.plugin_id,
      'router_link':d.selectPlugin,
      'localdata':true,
    };
  } else{
     params = {
      "zone_id": environment.ZONE_ID,
      "zone_code": environment.ZONE_CODE,
      "region_id": environment.REGION_ID,
      "region_code": environment.REGION_CODE,
      "plugin_id": false,
      'router_link':this.CurrentRouteFn(),
      'localdata':false,
    };
  }
  this.httpservice.PluginPageDetials(params).subscribe((response: HttpEvent<any>) => {
    switch (response.type) {
      case HttpEventType.Sent:
        //console.log('Sent' + HttpEventType.Sent);
        break;
      case HttpEventType.ResponseHeader:
        //console.log('ResponseHeader' + HttpEventType.ResponseHeader);
        break;
      case HttpEventType.UploadProgress:
        //this.evenTotal = response.total;
        //this.progress = Math.round(response.loaded / this.evenTotal * 100);
        break;
      case HttpEventType.Response:
      this.p_apirespons = response.body;
      let respData = this.p_apirespons.RESPONSE_DATA;
      let respToken = this.p_apirespons.RESPONSE_TOKEN;
      let verifyToken = CryptoJS.HmacSHA256(respData,environment.apiHashingKey).toString();
      if (respToken == verifyToken) { 
        let response_: any = Buffer.from(respData, 'base64');
        response_ = JSON.parse(response_);
        // console.log(response_.original);
        if(response_.original.status){
          this.P_data = response_.original;
          this.navMenu = response_.original.hasMenu;
          this.navmenuloadCss = "height: 100%;";
        } else {
          this.P_data = response_.original;//somthing wrong
        }
        this.showNavComponent=true;
        this.showBarComponent=true;
      } 
    }
  });
}


 
checkFileType(data:any):any{
  let ext:any,fileType:any;
  ext= ['webp','jpeg', 'jpe', 'png', 'gif', 'jpg', 'pdf', 'PNG','xlsx','xls','csv','docx','doc'];
  if(data==""){
    return false; 
  } 
  if(data.selectFile==""){
    return false; 
  }
  if(data.selectFile_details==undefined){
    return false; 
  }
  if(data.selectFile_details.fileType==undefined){
    return false; 
  }
  if(data.selectFile_details.fileType==''){
    return false; 
  }
  fileType=data.selectFile_details.fileType.toLowerCase();
  if(fileType=='xlsx' || fileType=='xls' || fileType=='csv'){
    return {'fileType':fileType,'file': ` ||<i class="fa fa-file-excel-o" aria-hidden="true"></i> ${fileType} ||`}; 
  } else if(fileType=='docx' || fileType=='doc'){
    return {'fileType':fileType,'file':` || <i class="fa fa-file-word-o" aria-hidden="true"></i> ${fileType} ||`}; 
  } else if(fileType=='pdf'){
    return {'fileType':fileType,'file':` || <i class="fa fa-file-pdf-o" aria-hidden="true"></i> ${fileType} ||`}; 
  } else {
    return {'fileType':fileType,'file':` || <i class="fa fa-file-text" aria-hidden="true"></i> ${fileType} ||`}; 
  }

}








}
